export default "__VITE_ASSET__3e8ab467__"